import { Tab as ReachTab } from '@reach/tabs';
import PropTypes from 'prop-types';

/**
 * @param {Object} props
 * @param {Boolean} props.isSelected
 * @param {React.ReactNode|React.ReactNode[]} props.children
 * @returns {React.ReactElement}
 */
const Tab = (props) => {
  const { isSelected, children, ...rest } = props;

  const selectedStyles = 'border-b-blue-3 border-b-4 text-blue-3';
  const unselectedStyles = 'border-b-gray-2 border-b-2 font-normal';

  return (
    <ReachTab
      className={`cursor-pointer border-t-0 border-l-0 border-r-0 rounded-none px-4 py-2 focus:shadow-none ${
        isSelected ? selectedStyles : unselectedStyles
      }`}
      {...rest}
    >
      {children}
    </ReachTab>
  );
};

Tab.defaultProps = {
  isSelected: false,
};

Tab.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  isSelected: PropTypes.bool,
};

export default Tab;
